import React, { useState } from "react";
import { tabsType } from "../../types";
import { TabContent } from "./TabContent";
import { TabNavItem } from "./TabNavItem";

export function Tabs({ definition }) {
	const initialActiveTab = definition[0].id;
	const [activeTab, setActiveTab] = useState(initialActiveTab);

	const [items, panes] = definition.reduce(
		([items, panes], item) => {
			const { id, title, content, loading } = item;

			items.push(
				<TabNavItem
					key={id}
					id={id}
					title={title}
					activeTab={activeTab}
					setActiveTab={setActiveTab}
				/>,
			);
			panes.push(
				<TabContent
					key={id}
					id={id}
					activeTab={activeTab}
					content={content}
					loading={loading}
				/>,
			);

			return [items, panes];
		},
		[[], []],
	);

	return (
		<div className="tabs">
			<nav className="tabs-nav">
				<ul role="tablist" className="tabs-list">
					{items}
				</ul>
			</nav>
			<div className="tabs-content">{panes}</div>
		</div>
	);
}

Tabs.propTypes = {
	definition: tabsType.isRequired,
};
